import * as React from "react";
import { Button } from "@/components/ui/button";
import { ChatContext } from "@/context/chat";

interface ButtonWidgetProps {
  label: string;
  action: string;
  onButtonClick: (
    messageIndex: number,
    widgetIndex: number,
    action: string,
    label: string,
  ) => void;
  messageIndex: number;
  widgetIndex: number;
}

export const ButtonWidget: React.FC<ButtonWidgetProps> = ({
  label,
  action,
  onButtonClick,
  messageIndex,
  widgetIndex,
}) => {
  const chatContext = React.useContext(ChatContext);

  if (!chatContext) {
    throw new Error("ButtonWidget must be used within a ChatProvider");
  }

  const handleClick = () => {
    onButtonClick(messageIndex, widgetIndex, action, label);
  };

  return <Button onClick={handleClick}>{label}</Button>;
};
